import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/episodes", label: "全部剧集" },
  { to: "/characters", label: "角色介绍" },
  { to: "/news", label: "影视资讯" },
  { to: "/search", label: "搜索内容" },
];

const friendlyLinks = [
  { to: "/episodes", label: "分集剧情大全" },
  { to: "/characters", label: "家庭剧角色图鉴" },
  { to: "/news", label: "播出动态速递" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-800 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold text-lg">
                公
              </span>
              <span className="font-heading font-bold text-lg text-background-50">公公与儿媳</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200">
              一个聚焦家庭题材电视剧《公公与儿媳》的剧情资料站，提供全集剧情介绍、角色分析与影视资讯，帮助影视爱好者了解剧情、追剧不迷路。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-base">
              网站导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-base">
              友情链接
            </h4>
            <ul className="space-y-2.5">
              {friendlyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-300 text-center sm:text-left">
            © 2026 公公与儿媳 · 剧情资料站。本站内容均为演示资料，不提供视频播放与下载服务。
          </p>
          <p className="text-xs text-secondary-300">
            仅供影视爱好者学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}